import { Component, Input, OnInit } from '@angular/core';
import { ProgressData } from './multi-color-progress-bar.interface';

@Component({
  selector: 'app-multi-color-progress-bar',
  templateUrl: './multi-color-progress-bar.component.html',
  styleUrls: ['./multi-color-progress-bar.component.scss'],
})
export class MultiColorProgressBarComponent implements OnInit {
  constructor() {}
  @Input() title!: string;
  @Input() headCount!: number;
  @Input() data!: ProgressData[];
  @Input() tootip:boolean = false;

  public colors = [
    '#377dc7',
    '#2866a7',
    '#215b97',
    '#154c86',
    '#0c3f76',
    '#0c3664',
    '#072d56',
  ];
  ngOnInit(): void {
    
  }
  ngAfterViewInit():void{
    // console.log(this.data)
  }
}
